import { render, staticRenderFns } from "./CFOApproval.vue?vue&type=template&id=2c4d8d9e&scoped=true"
import script from "./CFOApproval.vue?vue&type=script&lang=js"
export * from "./CFOApproval.vue?vue&type=script&lang=js"
import style0 from "./CFOApproval.vue?vue&type=style&index=0&id=2c4d8d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d8d9e",
  null
  
)

export default component.exports